// @flow
import React from 'react';
import type { Node } from 'react';

import { Provider, Connect } from '@rover/react-lib/components/utils/Redux';

import { reducer as address } from '@rover/react-lib/redux/ducks/address.duck';
import { reducer as currentUser } from '@rover/react-lib/redux/ducks/currentUser.duck';
import {
  reducer as creditCards,
  effects as creditCardsEffects,
  selectors as creditCardsSelectors,
} from '@rover/react-lib/redux/ducks/creditCards.duck';
import {
  reducer as countryConfiguration,
  effects as countryConfigurationEffects,
} from '@rover/react-lib/redux/ducks/countryConfiguration.duck';
import {
  reducer as frontendConfiguration,
  effects as frontendConfigurationEffects,
} from '@rover/react-lib/redux/ducks/frontendConfiguration.duck';

import {
  reducer as conversationsCheckoutPage,
  selectors as conversationsCheckoutPageSelectors,
  actions as conversationsCheckoutPageActions,
  effects as conversationsCheckoutPageEffects,
} from './ConversationsCheckoutPage.duck';
import ConversationsCheckoutPage from './ConversationsCheckoutPage';

import sagas from './sagas';
import type { AppProps } from './';

const selector = state => ({
  creditCards: creditCardsSelectors.getCreditCards(state),
  isLoading: conversationsCheckoutPageSelectors.getLoading(state),
});

const actions = {
  setServiceType: conversationsCheckoutPageActions.setServiceType,
};

const ConversationsCheckoutPageContainer = (props: AppProps): Node => (
  <Provider
    reducers={{
      address,
      currentUser,
      creditCards,
      countryConfiguration,
      conversationsCheckoutPage,
      frontendConfiguration,
    }}
    sagas={sagas}
  >
    <Connect
      selector={selector}
      actions={actions}
      onMount={[
        conversationsCheckoutPageEffects.prefetchData,
        creditCardsEffects.fetchCreditCards,
        frontendConfigurationEffects.fetchFrontendConfiguration,
        countryConfigurationEffects.fetchConfiguration,
      ]}
    >
      {redux => <ConversationsCheckoutPage {...redux} {...props} />}
    </Connect>
  </Provider>
);

export default ConversationsCheckoutPageContainer;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/ConversationsCheckoutPage/ConversationsCheckoutPageContainer.jsx